import * as React from "react";
import { Link } from "react-router-dom";

export function Footer(props){
    return (
        <footer>
            <div className="footer-content">
                <div className="footer-content-main">
                    <img src="/images/logo/logo_main.png"/>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/credits">Credits</Link></li>
                    </ul>
                </div>
                <p className="footer-credits">Website built and maintained by Ohara.<br/>Design by Ohara and Cath.</p>
            </div>
        </footer>
    )
}